<div class="div-center">
    <img src="./assets/splash/splash.gif" alt="juman logo"/>
</div>